import React from "react";
import u1 from "../../Assets/images/user.png";

const TableProfile = ({ imageSrc, TextclassNames, name }) => {
  return (
    <div className="d-flex align-items-center gap-10 ">
      <div
        className="imgWrp rounded-circle"
        style={{
          height: 40,
          width: 40,
          background: "#ddd",
        }}   
      >
        <img
          src={imageSrc === "null" || !imageSrc ? u1 : imageSrc}
          alt=""
          className="img-fluid h-100 w-100 rounded-circle"
          style={{ objectFit: "cover" }}
        />
      </div>
      <div className="content">
        <p className={`text-primary   m-0 fw-sbold ${TextclassNames}`}>
          {name?.charAt(0).toUpperCase()+ name?.slice(1)}
        </p>
      </div>
    </div>
  );
};

export default TableProfile;
